import React from 'react';
import useLocale from 'src/hooks/useLocale';

interface ArmingCountdownProps {
  secondsRemaining: number;
  totalSeconds: number;
}

const RADIUS = 42;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

// Revived from the deleted QrDisarmPage/ArmingCountdown, recolored to status-orange.
const ArmingCountdown: React.FC<ArmingCountdownProps> = ({ secondsRemaining, totalSeconds }) => {
  const locale = useLocale();
  const fractionRemaining = totalSeconds > 0 ? secondsRemaining / totalSeconds : 0;
  const dashOffset = CIRCUMFERENCE * (1 - fractionRemaining);

  return (
    <div className="relative size-40" data-testid="arming-countdown">
      <svg viewBox="0 0 100 100" className="size-full">
        <circle
          className="fill-none stroke-border-muted"
          cx="50"
          cy="50"
          r={RADIUS}
          strokeWidth={8}
        />
        <g transform="translate(100,0) scale(-1,1)">
          <circle
            className="fill-none stroke-status-orange"
            data-testid="arming-progress-circle"
            cx="50"
            cy="50"
            r={RADIUS}
            strokeWidth={8}
            strokeLinecap="round"
            transform="rotate(-90 50 50)"
            style={{
              strokeDasharray: CIRCUMFERENCE,
              strokeDashoffset: dashOffset,
              transition: 'stroke-dashoffset 1s linear',
            }}
          />
        </g>
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-status-orange heading-display" data-testid="arming-seconds">
          {secondsRemaining}
        </span>
        <span className="mt-0.5 text-foreground-secondary caption">{locale.general.seconds}</span>
      </div>
    </div>
  );
};

export default ArmingCountdown;
